import { useState } from "react"
import { Mail, Lock, User } from "lucide-react"
import { BRAND_NAME } from "../utils/config"

export default function SignIn(){

    const [mode, setMode] = useState("signin"); // 'signin' | 'signup'
    const [submitted, setSubmitted] = useState(false);

    function switchMode(newMode){
        setMode(newMode);
        setSubmitted(false);
    }

    function handleSubmit(e){
        e.preventDefault();
        setSubmitted(true);
    }

    return (
        <div className="w-full max-w-md mx-auto mt-16 mb-24 px-6">
            <div className="bg-cream border border-charcoal/10 shadow-sm rounded-2xl p-8">

                <div className="flex mb-8 border border-charcoal/15 rounded-full p-1">
                    <button
                        className={`flex-1 py-2 rounded-full text-sm font-medium transition ${mode==="signin" ? "bg-charcoal text-cream" : "text-charcoal/60"}`}
                        onClick={()=>switchMode("signin")}
                    >
                        Sign in
                    </button>
                    <button
                        className={`flex-1 py-2 rounded-full text-sm font-medium transition ${mode==="signup" ? "bg-charcoal text-cream" : "text-charcoal/60"}`}
                        onClick={()=>switchMode("signup")}
                    >
                        Create account
                    </button>
                </div>

                <h1 className="font-display text-3xl font-semibold text-charcoal mb-1">
                    {mode==="signin" ? "Welcome back" : `Join ${BRAND_NAME}`}
                </h1>
                <p className="text-charcoal/60 text-sm mb-6">
                    {mode==="signin" ? "Sign in to see your orders and saved restaurants." : "Create an account to start ordering."}
                </p>

                {
                    submitted
                    ? (
                        <div className="text-center py-8">
                            <p className="text-curry font-medium mb-2">This is a UI demo</p>
                            <p className="text-charcoal/60 text-sm">Sign-in and account creation aren't wired up to a real backend yet.</p>
                        </div>
                    )
                    : (
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            {
                                mode==="signup" &&
                                <div className="relative">
                                    <User className="w-5 h-5 text-charcoal/40 absolute left-4 top-1/2 -translate-y-1/2" />
                                    <input required type="text" placeholder="Full name" className="w-full py-3 pl-12 pr-4 bg-white/40 rounded-xl border border-charcoal/15 outline-none focus:border-turmeric focus:ring-2 focus:ring-turmeric/50 placeholder:text-charcoal/40" />
                                </div>
                            }
                            <div className="relative">
                                <Mail className="w-5 h-5 text-charcoal/40 absolute left-4 top-1/2 -translate-y-1/2" />
                                <input required type="email" placeholder="Email address" className="w-full py-3 pl-12 pr-4 bg-white/40 rounded-xl border border-charcoal/15 outline-none focus:border-turmeric focus:ring-2 focus:ring-turmeric/50 placeholder:text-charcoal/40" />
                            </div>
                            <div className="relative">
                                <Lock className="w-5 h-5 text-charcoal/40 absolute left-4 top-1/2 -translate-y-1/2" />
                                <input required type="password" placeholder="Password" className="w-full py-3 pl-12 pr-4 bg-white/40 rounded-xl border border-charcoal/15 outline-none focus:border-turmeric focus:ring-2 focus:ring-turmeric/50 placeholder:text-charcoal/40" />
                            </div>
                            <button type="submit" className="w-full py-3 bg-ember text-cream font-medium rounded-xl hover:brightness-110 transition">
                                {mode==="signin" ? "Sign in" : "Create account"}
                            </button>
                        </form>
                    )
                }
            </div>
        </div>
    )
}
